/** Founding creator rate applies to creators approved during launch (handoff). */
export function isFoundingPeriodActive(now = new Date()) {
  return now < new Date("2027-01-01T00:00:00.000Z");
}

export function foundingCreatorFields() {
  return {
    isFoundingContributor: true,
    foundingCreator: true,
    isFoundingMember: true,
    feeRate: 0.1,
  };
}
